export interface Assets {
    scripts: Array<string>;
    stylesheets: Array<string>;
}
